<div class="reklamieren-page" [class.reklamieren-page--dialog]="dialog">
    <kiene-mobile-page-header *ngIf="!dialog" [ueberschrift]="ueberschrift"></kiene-mobile-page-header>

    <div class="reklamieren-body">
    <div *ngIf="isLoading" class="reklamieren-loading">
        <span>Lade Tier...</span>
    </div>

    <div *ngIf="!isLoading" class="reklamieren-content">
        <h3 style="margin-block-end: 12px; margin-block-start: 0">Ohrmarke {{ this.tier?.ohrmarke_notnull }}</h3>

        <mat-hint style="text-align: justify; display: inline-block; font-size: 0.8em">
            <strong>Hinweis:</strong> Neue Tierreklamationen können über das + Symbol hinzufügt werden.
        </mat-hint>

        <div class="reklamieren-header-row" [style.margin-top]="dialog ? '8px' : '0'">
            <strong class="kiene-primary">Tierreklamationen Schnellauswahl</strong>
            <button
                data-cy="reklamieren-add"
                color="accent"
                mat-icon-button
                (click)="editTierreklamation($event)"
                [disabled]="!canEditTierreklamationMaster"
            >
                <mat-icon>add</mat-icon>
            </button>
        </div>

        <div *ngIf="!isLoading" class="reklamieren-list-wrapper">
            <div class="reklamieren-empty" *ngIf="tierreklamationCheckboxes.length === 0">
                <mat-hint style="font-size: 0.8em">Noch keine Tierreklamationen angelegt</mat-hint>
            </div>

            <div *ngIf="tierreklamationCheckboxes.length > 0" class="reklamieren-list-scroll">
                <div
                    (click)="
                        addSelected({ checked: !tierreklamationCheckbox.checked }, tierreklamationCheckbox, $event)
                    "
                    *ngFor="let tierreklamationCheckbox of tierreklamationCheckboxes; let index = index"
                    class="reklamieren-list-row"
                >
                    <mat-checkbox
                        id="reklamieren-reklamation-{{ index }}"
                        [checked]="tierreklamationCheckbox.checked"
                        (change)="addSelected($event, tierreklamationCheckbox)"
                    >
                        {{ tierreklamationCheckbox?.tierreklamation?.reklamation }}
                    </mat-checkbox>

                    <span class="spacer"></span>

                    <button
                        color="accent"
                        mat-icon-button
                        (click)="editTierreklamation($event, tierreklamationCheckbox?.tierreklamation)"
                        [disabled]="!canEditTierreklamationMaster"
                    >
                        <mat-icon>edit</mat-icon>
                    </button>
                </div>
            </div>
        </div>

        <div
            [style]="
                dialog
                    ? 'position: sticky; bottom: 0; background-color: white; padding: 12px 0 0 0;'
                    : 'padding-top: 16px'
            "
            class="one-row"
            [class.reklamieren-actions-dialog]="dialog"
            [style.justify-content]="dialog ? 'space-between' : 'center'"
        >
            <button
                class="reklamieren-save-button"
                color="accent"
                mat-flat-button
                data-cy="reklamieren-save"
                (click)="reklamationHinzufuegen()"
                [disabled]="isSaving"
            >
                Reklamation speichern
            </button>
            <span *ngIf="dialog" class="spacer"></span>
            <ng-content select="[additional-actions]"></ng-content>
        </div>
    </div>
    </div>
</div>
